import { render, staticRenderFns } from "./cModalProductList.vue?vue&type=template&id=c83bd95c&scoped=true"
import script from "./cModalProductList.vue?vue&type=script&lang=js"
export * from "./cModalProductList.vue?vue&type=script&lang=js"
import style0 from "./cModalProductList.vue?vue&type=style&index=0&id=c83bd95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83bd95c",
  null
  
)

export default component.exports